import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import HeroOne from '../components/hero/HeroOne';
import AboutTwo from '../components/about/AboutTwo';
import FeatureThree from '../components/features/FeatureThree';
import FaqOne from '../components/faq/FaqOne';
import WorkPerformanceOne from '../components/work-performance/WorkPerformanceOne';
import PricingOne from '../components/pricing/PricingOne';
import BrandOne from '../components/brand/BrandOne';
import BlogOne from '../components/blog/BlogOne';
import CounterOne from '../components/counter/CounterOne';
import FooterOne from '../common/footer/FooterOne';

const HomeFive = () => {
    return (
        <>
            <HeaderOne />
            <HeroOne />
            <AboutTwo />
            <FeatureThree />
            <FaqOne />
            <WorkPerformanceOne />
            <PricingOne />
            <BrandOne />
            <BlogOne />
            <CounterOne />
            <FooterOne />
        </>
    )
}

export default HomeFive;